/* eslint-disable import/prefer-default-export */
export const rateCardQueryKeys = {
  rateCardListing: (filters: any) => ["rate-card", "list", filters],
  rateCardDetails: (id: string) => ["rate-card", "detail", id],
  rateCardTemplates: () => ["rate-card", "templates"],
};
